import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const checkAnalysisHasRequirementsNotMet = (
  analysisAutomationItems: AutomationFormItem[]
) => {
  return analysisAutomationItems.some((item) => {
    return item.requirementConditions.some((condition) => {
      if (
        condition.type ===
        RequirementConditionType.CandidateRequirementsMetCondition
      ) {
        return condition.operator === RequirementConditionOperator.IsFalse;
      }
      return false;
    });
  });
};
